import {sleep} from '@benchling/js-utils';

/**
 *  Enforces a minimum time-to-return. This is useful for UX; e.g., to ensure that a loading
 *  spinner doesn't flash on & off too quickly. For example:
 *
 *     OLD CODE:
 *       showLoadingState();
 *       await myApi();
 *       hideLoadingState();
 *
 *     NEW CODE:
 *       showLoadingState();
 *       await bufferForUX(myApi());
 *       hideLoadingState();
 *
 *  Note that this tool doesn't render any loading state. It merely helps you throttle
 *  your API so that the loading state doesn't hide too quickly.
 *
 *  Also note that there are other patterns available:
 *   - Simply do not show a loading indicator if the operation will take under a second
 *   - Optimistically update your UI state while waiting for the server response
 */

export default async function bufferForUX<T>(promise: Promise<T>, minTimeToReturn: number = 600): Promise<T> {
  await sleep(minTimeToReturn);
  return await promise;
}
